function parseBool(value: unknown): boolean {
    if (typeof value === "string") {
        if (value === "false") {
            return false;
        }
        if (value === "true") {
            return true;
        }
        return false;
    }
    return Boolean(value);
}

export const clientSettings = {
    authorized: parseBool("{authorized}"),
    cauldronApiUrl: "{cauldronApiUrl}",
    isTestServer: parseBool("{isTestServer}"),
    renderCachingForIE8: parseBool("{renderCachingForIE8}"),
    normalizationOnServer: parseBool("{normalizationOnServer}"),
    normativeUrl: "{normativeUrl}",
    ndsPlusApiUrl: "{ndsPlusApiUrl}",
    konturDomains: "{konturDomains}",
};
